<template>
<div>
    <div class="row">
        <div class="col-md-12 ">
            <ExtentList @checkChange="handleCheckChangeParent" />
        </div>
    </div>
    <el-button type="primary" @click="add_blank_rule()">Add a Rule</el-button>
    <el-button type="info" @click="run_ruleset()">Run this ruleset</el-button>
    <el-button type="info" v-on:click="example">Add example rule</el-button>
    <el-button type="info" v-on:click="go_full">Rule Editor</el-button>


    <ol style="margin-top:40px;">
        <li v-for="sentence in sentences">
            {{ sentence.sentence }}
        </li>
    </ol>

    <ol style="margin-top:40px;">
        <li v-for="disposition in dispositions">
            {{ disposition.title }}
        </li>
    </ol>
</div>
</template>

<script>
//    import component2 from './component2.vue'
    export default {
        props: ['ruleset_id','extent_id'],
        mounted() {
            // console.log('RuleSetSimple component mounted now.')
            // console.log('ruleset_id is ' + this.ruleset_id )
            axios.post('/api/flattened/trigger/' + this.ruleset_id)
                .then(response => {
                    // console.log("just completed flattening")
                    this.load_data()
                    // console.log('About to get dispositions')
                })
                .catch(error => {
                    console.log('oops flattening')
                })
            this.get_dispositions()
        },
        watch: {
            extent_id: function (newValue, oldValue) {
                this.load_ruleset_after_extent_change()
            }
        },
        data() {
            return {
                counter: 0,
                columns: [{prop: 'rule_id', label:'Rule ID', width: 180},{prop: 'name', label: 'Name', width: 180}],
                array_data:[],
                active_edit_cell: {rule_id: null, header_name: null, new_value: null},
                cell_input: '',
                available_fields: '',
                selected_new_field: '',
                show_new_field_overlay: false,
                sentences: '',
                dispositions: ''
        }},
        components: {},
        methods: {
            get_dispositions() {
                // console.log('about to get dispositions from statamic')
              axios.get('/api/CE/dispositions')
                  .then(response => {
                      // console.log("got dispositions")
                      this.dispositions = response.data
                      // console.log(this.dispositions)
                  })
                  .catch(error => {
                      console.log('oops loading dispositions')
                  })
            },
            add_blank_rule() {
                axios.post('/api/flattened/' + this.ruleset_id + '/add_blank_rule', {
                }).then(response => {
                    // console.log('added a blank rule in the backend successfully')
                    // console.log(response)
                    this.load_data()
                })
            },
            example() {
                axios.post('/api/flattened/example', {
                    ruleset_id: this.ruleset_id
                }).then(response => {
                        // console.log(response)
                        this.load_data()
                })
            },
            load_data() {
                axios.get('/api/rule_set_as_sentences/' + this.ruleset_id)
                    .then(response => {
                        // console.log(response.data)
                        this.sentences = response.data
                        // console.log(this.sentences)
                    })
                    .catch(error => {
                        console.log('oops loading sentences')
                    })
            },
            listener() {
                // console.log('listen')
            },
            delete_row(rule_id) {
                // console.log(this.ruleset_id)
                // console.log(rule_id)
                axios.delete('/api/flattened/' + this.ruleset_id + '/' + rule_id, {
                }).then(response => {
                    // console.log(response)
                    this.load_data()
                })
            },
            add_field() {
                // console.log("about to add a field")
                axios.post('/api/flattened/' + this.ruleset_id + '/columns',  {
                    new_column: this.selected_new_field
                }).then(response => {
                    // console.log(response)
                    this.load_data()
                    this.show_new_field_overlay = false
                })
            },
            run_ruleset() {
                axios.post('/api/jobChains', {
                    flattened_id: this.ruleset_id,
                    type: "assign"
                }).then(response => {
                    // console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    // console.log('oops starting job chain')
                    // console.log(response)
                })
            },
            move_row(rule_id) {
                axios.patch('/api/flattened/' + this.ruleset_id + '/' + rule_id, {
                    new_position: this.cell_input
                }).then(response => {
                    // console.log('successfully moved row')
                    // console.log(response)
                    this.unselect_current_cell()
                    this.load_data()
                }).catch(error => {
                    console.log('oops row move problem')
                    console.log(response)
                    })
            },
            cell_change() {
                // console.log("in cell_change()")
                if (this.header_name == 'order') {
                    // change order
                    // console.log("about to change the order")
                } else {
                    // change cell value
                    // console.log("changing something other than the order")
                    axios.patch('/api/flattened/' + this.ruleset_id + '/' + this.active_edit_cell.rule_id + '/' + this.active_edit_cell.header_name, {
                        new_value: this.cell_input
                    }).then(response => {
                        this.load_data()
                        this.unselect_current_cell()
                        // console.log(response)
                    })
                }
            },
            load_ruleset_after_extent_change() {
                axios.get('/extents/ruleset/' + this.extent_id)
                    .then(response => {
                        this.ruleset_id = response.data.id
                        this.load_data()
                        axios.get('/api/flattened/' + this.ruleset_id + '/columns/available')
                            .then(response => {
                                this.available_fields = response.data
                                // console.log(this.array_data)
                            })
                            .catch(error => {
                                console.log('oops getting columns available data')
                            })
                    })
                    .catch(error => {
                        console.log('oops problem changing extent')
                    })
            },
            handleCheckChangeParent(selected_extent) {
                this.extent_id = selected_extent.id
                this.load_ruleset_after_extent_change()
            },
            go_full() {
                window.location.href = "/rules/"
            }
        }
    }
</script>
